export const GOOGLE_EVENT_ID = {
  form: 'form_submit_button',
  cta: 'cta_button',
  download: 'download_button',
  share: 'share_button',
  hyperLink: 'pdf_hyperlink',
  messageBoxDot: 'message_box',
  messageBoxButton: 'message_button',
};
